import { ReactNode } from "react";
import Navbar from "../../pages/home/components/Navbar";
import Footer from "../../pages/home/components/Footer";

interface Props {
  children: ReactNode;
}

export default function InnerPageLayout({ children }: Props) {
  return (
    <div className="min-h-screen bg-brand-bg text-white font-body overflow-x-hidden">
      <Navbar />
      <main className="pt-14 md:pt-16">
        {children}
      </main>
      <Footer />
    </div>
  );
}
